class HoodieEditorialGallery extends HTMLElement {
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.hero=this.querySelector('.he-hero-image');
    this.variants=JSON.parse(this.querySelector('[data-he-variants]').textContent);
    this.addEventListener('click',e=>{
      const buttons=[...this.querySelectorAll('.he-thumbs button')];
      const step=e.target.closest('[data-he-step]');
      const index=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');
      const button=step?buttons[(index+Number(step.dataset.heStep)+buttons.length)%buttons.length]:e.target.closest('.he-thumbs button');
      if(button)this.show(button);
    });
    this.change=e=>{
      const input=e.target;
      if(!input.matches('variant-picker input')||input.dataset.optionName?.toUpperCase()!=='COLOR')return;
      const variant=this.variants.find(v=>v.option1===input.value);
      const button=this.querySelector(`[data-he-id="${variant?.featured_media?.id||variant?.featured_image?.id}"]`);
      if(button)this.show(button);
    };
    document.addEventListener('change',this.change);
  }
  show(button){
    this.hero.removeAttribute('srcset');this.hero.src=button.dataset.heSrc;this.hero.alt=button.dataset.heAlt;
    this.querySelectorAll('.he-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    const strip=this.querySelector('.he-thumbs');strip.scrollTo({left:button.offsetLeft-strip.offsetLeft-(strip.clientWidth-button.clientWidth)/2,behavior:'auto'});
  }
  disconnectedCallback(){document.removeEventListener('change',this.change)}
}
if(!customElements.get('hoodie-editorial-gallery'))customElements.define('hoodie-editorial-gallery',HoodieEditorialGallery);
class HoodieEditorialStorySlot extends HTMLElement {
  connectedCallback(){
    if(this.story)return;
    this.story=this.closest('.he-page')?.querySelector('.he-details-grid > .he-story');if(!this.story)return;
    this.origin=document.createComment('hoodie-story-mobile');this.story.before(this.origin);
    this.desktop=window.matchMedia('(min-width:990px)');
    this.place=()=>{if(this.desktop.matches)this.append(this.story);else this.origin.after(this.story)};
    this.desktop.addEventListener('change',this.place);this.place();
  }
  disconnectedCallback(){this.desktop?.removeEventListener('change',this.place);if(this.origin?.isConnected)this.origin.after(this.story);this.origin?.remove();this.story=null}
}
if(!customElements.get('hoodie-editorial-story-slot'))customElements.define('hoodie-editorial-story-slot',HoodieEditorialStorySlot);
